import AllMou from "pages/allMou";
import Auth from "pages/auth";
import Authors from "pages/authors";
import BookDetail from "pages/bookDetail";
import BookReviewer from "pages/bookReviewer";
import BookReviewers from "pages/bookReviewers";
import Books from "pages/books";
import BooksCatalog from "pages/booksCatalog";
import BooksListing from "pages/booksListing";
import Chats from "pages/chat";
import CustomeSupport from "pages/customerSupport";
import DashboardAccountant from "pages/dashboardAccountant";
import DashboardAdmin from "pages/dashboardAdmin";
import DashboardBookReviewer from "pages/dashboardBookReviewer";
import DashboardHead from "pages/dashboardHead";
import DashboardHOD from "pages/dashboardHOD";
import DashboardManager from "pages/dashboardManager";
import FeaturedBooks from "pages/featuredBooks";
import HardCopy from "pages/hardCopy";
import Membership from "pages/membership";
import MOU from "pages/mou";
import PublisherProfile from "pages/publisherProfile";
import Publishers from "pages/publishers";
import RequiredBooks from "pages/reportedBooks";
import Review from "pages/review";
import ReviewByHOD from "pages/reviewHOD";
import Settings from "pages/settings";
import Ticket from "pages/singleTicket";
import SoftCopy from "pages/softCopy";
import Tickets from "pages/tickets";
import Transactions from "pages/transactions";
import SchoolAnalytics from "pages/schoolAnalytics";
import SchoolAnalyticsDetail from "pages/schoolAnalyticsDetail";
import { routeConstant } from "./routesConstant";
// import BestSellers from "pages/bestSeller";
import Accounts from "pages/account";
import TermsAndPolicy from "pages/agreement";
import AliflailaUsers from "pages/aliflailaUser";
import AuthorProfile from "pages/authorProfile";
import Banners from "pages/banner";
import BookPreview from "pages/bookPreview";
import BookRevisions from "pages/bookRevisions";
import MOUSignature from "pages/mouSignature";
import NewsLetterSubscriptions from "pages/newsletterSubscriptions";
import Parents from "pages/parents";
import PartnerAccount from "pages/partnersAccount";
import ReportBookDetails from "pages/reportBookDetails";
import ReportDetails from "pages/reportDetail";
import ReportedUsers from "pages/reportedUsers";
import ReviewerPerformance from "pages/reviewerPerformance";
import ReviewersPerformace from "pages/reviewersPerformance";
import Sales from "pages/sales";
import SchoolAccounts from "pages/schoolAccounts";
import SchoolUsers from "pages/aliflailaSchoolUser";
import SchoolRequests from "pages/schoolRequests";
import SchoolTickets from "pages/schoolTickets";
import SubscriptionRequest from "pages/subscriptionRequest";
import Subscriptions from "pages/subscriptions";
import TopSales from "pages/topSales";
import TransactionHistory from "pages/transactionHistory";
import Notifications from "pages/notifications";
import CustomNotifications from "pages/customNotifications";
import NotificationListings from "pages/notificationListings";
import BannerControl from "pages/bannerControl";
import ManageBanner from "pages/manageBanner";
import SeriesDetail from "../../pages/seriesDetail";
import ReviewSeriesByHOD from "../../pages/reviewSeriesHOD";
import SeriesRevisions from "../../pages/seriesRevisions";
import ReviewSeries from "../../pages/reviewSeries";
import BookAudioRevisions from "../../pages/bookAudioRevisions";
import SeriesHOD from "../../pages/seriesHOD";
import Series from "../../pages/series";
import PromoCodes from "../../pages/filter/promoCodes";
import QRCodeOverview from "../../pages/qrCode/overview";
import QRManagement from "../../pages/qrCode/management";
import AuthorsListing from "pages/authorsListing";
import AppAnalyticsOverview from "pages/appAnalytics/overview";
import AppAnalyticsInstalls from "pages/appAnalytics/installs";
import AppAnalyticsUninstalls from "pages/appAnalytics/uninstalls";
import AppAnalyticsDevices from "pages/appAnalytics/devices";
import AppAnalyticsActivity from "pages/appAnalytics/activity";
import AppAnalyticsRetention from "pages/appAnalytics/retention";
import Subscription from "pages/subscription";
import PurchasedPlansHistory from "pages/purchasedPlansHistory";
import DashboardHeadNew from "pages/phNewDashboard";
import PhNewAccountsDetail from "pages/phNewAccountsDetail";
import PhNewPartnersDetail from "pages/phNewPartnersDetail";
import PhNewEarningDetail from "pages/phNewEarningDetail";
import PhNewApproveRequests from "pages/phNewApproveRequests";
import PhNewPartnerAccount from "pages/phNewPartnersAccount";
import PhNewPublisherProfile from "pages/phNewPublisherProfile";
import PhNewAuthorProfile from "pages/phNewAuthorProfile";
import PhNewMouSignature from "pages/phNewMouSignature";
import PhNewPartners from "pages/phNewPartners";
import PhNewTransaction from "pages/phNewTransaction";
import PhNewBooksSummary from "pages/phNewBooksSummary";
import PhNewControlCenter from "pages/phNewControlCenter";
import PhNewLeadershipBoard from "pages/phNewLeadershipBoard";
import PhNewDashboardView from "pages/phNewDashboardView";
import PhNewTermsAndPolicy from "pages/phNewTermsAndPolicy";
import PhNewPendingTasks from "pages/phNewPendingTasks";
import PhNewAllMouSignature from "pages/phNewAllMouSignature";
import AllPlansTransactions from "pages/AllPlansTransactions";
import AllBooksListings from "pages/allBooksListings";
import ManageBooks from "pages/manageBooks";
import PartnersListing from "pages/partnersListings";
import DemoRequests from "pages/demoRequests";
import DemoRequestDetail from "pages/demoRequests/detail";
import DemoRequestCreatePlan from "pages/demoRequests/createPlan";
import DemoRequestSchoolDetail from "pages/demoRequests/schoolDetail";

const publicRoutes = [
  {
    path: routeConstant.auth.path,
    title: routeConstant.auth.title,
    Component: Auth,
  },
];

const commonRoutes = [
  {
    path: routeConstant.settings.path,
    title: routeConstant.settings.title,
    Component: Settings,
  },
  {
    path: routeConstant.bookPreview.path,
    title: routeConstant.bookPreview.title,
    Component: BookPreview,
  },
  {
    path: routeConstant.notifications.path,
    title: routeConstant.notifications.title,
    Component: Notifications,
  },
];

const adminRoutes = [
  ...commonRoutes,
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardAdmin,
  },
  {
    path: routeConstant.tickets.path,
    title: routeConstant.tickets.title,
    Component: Tickets,
  },
  {
    path: routeConstant.publishers.path,
    title: routeConstant.publishers.title,
    Component: Publishers,
  },
  {
    path: routeConstant.chat.path,
    title: routeConstant.chat.title,
    Component: Chats,
  },
  {
    path: routeConstant.books.path,
    title: routeConstant.books.title,
    Component: Books,
  },
  {
    path: routeConstant.author.path,
    title: routeConstant.author.title,
    Component: Authors,
  },
  {
    path: routeConstant.bookReviewer.path,
    title: routeConstant.bookReviewer.title,
    Component: BookReviewers,
  },
  {
    path: routeConstant.publisherProfile.path,
    title: routeConstant.publisherProfile.title,
    Component: PublisherProfile,
  },
  {
    path: routeConstant.singleAuthor.path,
    title: routeConstant.singleAuthor.title,
    Component: AuthorProfile,
  },
  {
    path: routeConstant.mou.path,
    title: routeConstant.mou.title,
    Component: MOU,
  },
  {
    path: routeConstant.singleTicket.path,
    title: routeConstant.singleTicket.title,
    Component: Ticket,
  },
  {
    path: routeConstant.bookDetail.path,
    title: routeConstant.bookDetail.title,
    Component: BookDetail,
  },
  {
    path: routeConstant.seriesDetail.path,
    title: routeConstant.seriesDetail.title,
    Component: SeriesDetail,
  },
  // School Tabs
  {
    path: routeConstant.schoolAnalytics.path,
    title: routeConstant.schoolAnalytics.title,
    Component: SchoolAnalytics,
  },
  {
    path: routeConstant.schoolAnalyticsDetail.path,
    title: routeConstant.schoolAnalyticsDetail.title,
    Component: SchoolAnalyticsDetail,
  },
  {
    path: routeConstant.schoolAccounts.path,
    title: routeConstant.schoolAccounts.title,
    Component: SchoolAccounts,
  },

  {
    path: routeConstant.schoolRequests.path,
    title: routeConstant.schoolRequests.title,
    Component: SchoolRequests,
  },
  {
    path: routeConstant.schoolTickets.path,
    title: routeConstant.schoolTickets.title,
    Component: SchoolTickets,
  },
  {
    path: routeConstant.bookReview.path,
    title: routeConstant.bookReview.title,
    Component: BookReviewer,
  },
  {
    path: routeConstant.demoRequests.path,
    title: routeConstant.demoRequests.title,
    Component: DemoRequests,
  },
  {
    path: routeConstant.demoRequestDetail.path,
    title: routeConstant.demoRequestDetail.title,
    Component: DemoRequestDetail,
  },
  {
    path: routeConstant.demoRequestCreatePlan.path,
    title: routeConstant.demoRequestCreatePlan.title,
    Component: DemoRequestCreatePlan,
  },
  {
    path: routeConstant.demoRequestSchoolDetail.path,
    title: routeConstant.demoRequestSchoolDetail.title,
    Component: DemoRequestSchoolDetail,
  },
];

const HODRoutes = [
  ...commonRoutes,
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardHOD,
  },
  {
    path: routeConstant.bookDetail.path,
    title: routeConstant.bookDetail.title,
    Component: BookDetail,
  },
  {
    path: routeConstant.seriesDetail.path,
    title: routeConstant.seriesDetail.title,
    Component: SeriesDetail,
  },
  {
    path: routeConstant.bookReviewer.path,
    title: routeConstant.bookReviewer.title,
    Component: BookReviewers,
  },
  {
    path: routeConstant.bookReview.path,
    title: routeConstant.bookReview.title,
    Component: BookReviewer,
  },
  {
    path: routeConstant.books.path,
    title: routeConstant.books.title,
    Component: Books,
  },
  {
    path: routeConstant.series.path,
    title: routeConstant.series.title,
    Component: SeriesHOD,
  },
  {
    path: routeConstant.reviewByHOD.path,
    title: routeConstant.reviewByHOD.title,
    Component: ReviewByHOD,
  },
  {
    path: routeConstant.reviewSeriesByHOD.path,
    title: routeConstant.reviewSeriesByHOD.title,
    Component: ReviewSeriesByHOD,
  },
  {
    path: routeConstant.review.path,
    title: routeConstant.review.title,
    Component: Review,
  },
  {
    path: routeConstant.reviewSeries.path,
    title: routeConstant.reviewSeries.title,
    Component: ReviewSeries,
  },
  {
    path: routeConstant.bookRevisions.path,
    title: routeConstant.bookRevisions.title,
    Component: BookRevisions,
  },
  {
    path: routeConstant.bookAudioRevisions.path,
    title: routeConstant.bookAudioRevisions.title,
    Component: BookAudioRevisions,
  },
  {
    path: routeConstant.seriesRevisions.path,
    title: routeConstant.seriesRevisions.title,
    Component: SeriesRevisions,
  },
];

const bookReviewerRoutes = [
  ...commonRoutes,
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardBookReviewer,
  },
  {
    path: routeConstant.bookDetail.path,
    title: routeConstant.bookDetail.title,
    Component: BookDetail,
  },
  {
    path: routeConstant.seriesDetail.path,
    title: routeConstant.seriesDetail.title,
    Component: SeriesDetail,
  },
  {
    path: routeConstant.books.path,
    title: routeConstant.books.title,
    Component: BooksListing,
  },
  {
    path: routeConstant.series.path,
    title: routeConstant.series.title,
    Component: Series,
  },
  {
    path: routeConstant.review.path,
    title: routeConstant.review.title,
    Component: Review,
  },
  {
    path: routeConstant.reviewSeries.path,
    title: routeConstant.reviewSeries.title,
    Component: ReviewSeries,
  },
  {
    path: routeConstant.bookRevisions.path,
    title: routeConstant.bookRevisions.title,
    Component: BookRevisions,
  },
  {
    path: routeConstant.seriesRevisions.path,
    title: routeConstant.seriesRevisions.title,
    Component: SeriesRevisions,
  },
];

const accountantRoutes = [
  ...commonRoutes,
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardAccountant,
  },
  {
    path: routeConstant.publisherProfile.path,
    title: routeConstant.publisherProfile.title,
    Component: PublisherProfile,
  },
  {
    path: routeConstant.transactions.path,
    title: routeConstant.transactions.title,
    Component: Transactions,
  },
  {
    path: routeConstant.accounts.path,
    title: routeConstant.accounts.title,
    Component: Accounts,
  },
  {
    path: routeConstant.promoCodes.path,
    title: routeConstant.promoCodes.title,
    Component: PromoCodes,
  },
];

const productManagerRoutes = [
  ...commonRoutes,
  // Opened from the School Analytics tab on School Users.
  {
    path: routeConstant.schoolAnalyticsDetail.path,
    title: routeConstant.schoolAnalyticsDetail.title,
    Component: SchoolAnalyticsDetail,
  },
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardManager,
  },
  {
    path: routeConstant.softCopy.path,
    title: routeConstant.softCopy.title,
    Component: SoftCopy,
  },
  {
    path: routeConstant.hardCopy.path,
    title: routeConstant.hardCopy.title,
    Component: HardCopy,
  },
  {
    path: routeConstant.booksCatalog.path,
    title: routeConstant.booksCatalog.title,
    Component: BooksCatalog,
  },
  {
    path: routeConstant.featuredBooks.path,
    title: routeConstant.featuredBooks.title,
    Component: FeaturedBooks,
  },
  {
    path: routeConstant.customerSupport.path,
    title: routeConstant.customerSupport.title,
    Component: CustomeSupport,
  },
  {
    path: routeConstant.membership.path,
    title: routeConstant.membership.title,
    Component: Membership,
  },
  {
    path: routeConstant.requiredBooks.path,
    title: routeConstant.requiredBooks.title,
    Component: RequiredBooks,
  },
  {
    path: routeConstant.aliflailaSchoolUsers.path,
    title: routeConstant.aliflailaSchoolUsers.title,
    Component: SchoolUsers,
  },
  // {
  //   path: routeConstant.school.path,
  //   title: routeConstant.school.title,
  //   Component: School,
  // },
  {
    path: routeConstant.publisherProfile.path,
    title: routeConstant.publisherProfile.title,
    Component: PublisherProfile,
  },
  {
    path: routeConstant.singleTicket.path,
    title: routeConstant.singleTicket.title,
    Component: Ticket,
  },
  {
    path: routeConstant.bookDetail.path,
    title: routeConstant.bookDetail.title,
    Component: BookDetail,
  },
  {
    path: routeConstant.seriesDetail.path,
    title: routeConstant.seriesDetail.title,
    Component: SeriesDetail,
  },
  {
    path: routeConstant.reportBookDetails.path,
    title: routeConstant.reportBookDetails.title,
    Component: ReportBookDetails,
  },
  {
    path: routeConstant.bookRevisions.path,
    title: routeConstant.bookRevisions.title,
    Component: BookRevisions,
  },
  {
    path: routeConstant.seriesRevisions.path,
    title: routeConstant.seriesRevisions.title,
    Component: SeriesRevisions,
  },
  {
    path: routeConstant.sales.path,
    title: routeConstant.sales.title,
    Component: Sales,
  },
  {
    path: routeConstant.subscriptionRequest.path,
    title: routeConstant.subscriptionRequest.title,
    Component: SubscriptionRequest,
  },

  {
    path: routeConstant.subscriptions.path,
    title: routeConstant.subscriptions.title,
    Component: Subscriptions,
  },
  {
    path: routeConstant.privacyPolicy.path,
    title: routeConstant.privacyPolicy.title,
    Component: TermsAndPolicy,
  },
  {
    path: routeConstant.termsAndCondition.path,
    title: routeConstant.termsAndCondition.title,
    Component: TermsAndPolicy,
  },
  {
    path: routeConstant.aliflailaIndividualUsers.path,
    title: routeConstant.aliflailaIndividualUsers.title,
    Component: AliflailaUsers,
  },
  // {
  //   path: routeConstant.individualDetail.path,
  //   title: routeConstant.individualDetail.title,
  //   Component:,
  // },
  {
    path: routeConstant.parentUsers.path,
    title: routeConstant.parentUsers.title,
    Component: Parents,
  },
  {
    path: routeConstant.author.path,
    title: routeConstant.auth.title,
    Component: Authors,
  },
  {
    path: routeConstant.authorsListing.path,
    title: routeConstant.authorsListing.title,
    Component: AuthorsListing,
  },
  {
    path: routeConstant.newsletterSubscription.path,
    title: routeConstant.newsletterSubscription.title,
    Component: NewsLetterSubscriptions,
  },
  {
    path: routeConstant.transactionHistory.path,
    title: routeConstant.transactionHistory.title,
    Component: TransactionHistory,
  },
  {
    path: routeConstant.banners.path,
    title: routeConstant.banners.title,
    Component: Banners,
  },
  // {
  //   path: routeConstant.parentDetail.path,
  //   title: routeConstant.parentDetail.title,
  //   Component:,
  // }
  {
    path: routeConstant.customNotifications.path,
    title: routeConstant.customNotifications.title,
    Component: CustomNotifications,
  },
  {
    path: routeConstant.notificationListings.path,
    title: routeConstant.notificationListings.title,
    Component: NotificationListings,
  },
  {
    path: routeConstant.manageBanner.path,
    title: routeConstant.manageBanner.title,
    Component: ManageBanner,
  },
  {
    path: routeConstant.bannerControl.path,
    title: routeConstant.bannerControl.title,
    Component: BannerControl,
  },
  {
    path: routeConstant.qrCodeOverview.path,
    title: routeConstant.qrCodeOverview.title,
    Component: QRCodeOverview,
  },
  {
    path: routeConstant.qrCodeManagement.path,
    title: routeConstant.qrCodeManagement.title,
    Component: QRManagement,
  },
  {
    path: routeConstant.appAnalyticsOverview.path,
    title: routeConstant.appAnalyticsOverview.title,
    Component: AppAnalyticsOverview,
  },
  {
    path: routeConstant.appAnalyticsInstalls.path,
    title: routeConstant.appAnalyticsInstalls.title,
    Component: AppAnalyticsInstalls,
  },
  {
    path: routeConstant.appAnalyticsUninstalls.path,
    title: routeConstant.appAnalyticsUninstalls.title,
    Component: AppAnalyticsUninstalls,
  },
  {
    path: routeConstant.appAnalyticsDevices.path,
    title: routeConstant.appAnalyticsDevices.title,
    Component: AppAnalyticsDevices,
  },
  {
    path: routeConstant.appAnalyticsActivity.path,
    title: routeConstant.appAnalyticsActivity.title,
    Component: AppAnalyticsActivity,
  },
  {
    path: routeConstant.appAnalyticsRetention.path,
    title: routeConstant.appAnalyticsRetention.title,
    Component: AppAnalyticsRetention,
  },
];

const projectHeadRoutes = [
  ...commonRoutes,

  {
    path: routeConstant.schoolAnalytics.path,
    title: routeConstant.schoolAnalytics.title,
    Component: SchoolAnalytics
  },
  {
    path: routeConstant.schoolAnalyticsDetail.path,
    title: routeConstant.schoolAnalyticsDetail.title,
    Component: SchoolAnalyticsDetail
  },
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardHead,
  },
  {
    path: routeConstant.allMou.path,
    title: routeConstant.allMou.title,
    Component: AllMou,
  },
  {
    path: routeConstant.transactions.path,
    title: routeConstant.transactions.title,
    Component: Transactions,
  },
  {
    path: routeConstant.bestSellers.path,
    title: routeConstant.bestSellers.title,
    Component: TopSales,
  },
  {
    path: routeConstant.reviewersPerformance.path,
    title: routeConstant.reviewersPerformance.title,
    Component: ReviewersPerformace,
  },
  {
    path: routeConstant.partnerAccount.path,
    title: routeConstant.partnerAccount.title,
    Component: PartnerAccount,
  },
  {
    path: routeConstant.mou.path,
    title: routeConstant.mou.title,
    Component: MOU,
  },
  {
    path: routeConstant.publisherProfile.path,
    title: routeConstant.publisherProfile.title,
    Component: PublisherProfile,
  },
  {
    path: routeConstant.bookDetail.path,
    title: routeConstant.bookDetail.title,
    Component: BookDetail,
  },
  {
    path: routeConstant.seriesDetail.path,
    title: routeConstant.seriesDetail.title,
    Component: SeriesDetail,
  },
  {
    path: routeConstant.reviewerPerformance.path,
    title: routeConstant.reviewerPerformance.title,
    Component: ReviewerPerformance,
  },
  {
    path: routeConstant.reportedUsers.path,
    title: routeConstant.reportedUsers.title,
    Component: ReportedUsers,
  },
  {
    path: routeConstant.reports.path,
    title: routeConstant.reports.title,
    Component: ReportDetails,
  },
  {
    path: routeConstant.mouHead.path,
    title: routeConstant.mouHead.title,
    Component: MOUSignature,
  },
  {
    path: routeConstant.singleAuthor.path,
    title: routeConstant.singleAuthor.title,
    Component: AuthorProfile,
  },
  {
    path: routeConstant.newsletterSubscription.path,
    title: routeConstant.newsletterSubscription.title,
    Component: NewsLetterSubscriptions,
  },
  {
    path: routeConstant.subscriptions.path,
    title: routeConstant.subscriptions.title,
    Component: Subscriptions,
  },
  {
    path: routeConstant.customNotifications.path,
    title: routeConstant.customNotifications.title,
    Component: CustomNotifications,
  },
  {
    path: routeConstant.notificationListings.path,
    title: routeConstant.notificationListings.title,
    Component: NotificationListings,
  },
];
const projectHeadNewRoutes = [
  ...commonRoutes,

  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardHeadNew
  },
  {
    path: routeConstant.usersAccountsDetail.path,
    title: routeConstant.usersAccountsDetail.title,
    Component: PhNewAccountsDetail
  },
  {
    path: routeConstant.partnersDetail.path,
    title: routeConstant.partnersDetail.title,
    Component: PhNewPartnersDetail
  },
  {
    path: routeConstant.earningDetail.path,
    title: routeConstant.earningDetail.title,
    Component: PhNewEarningDetail
  },
  {
    path: routeConstant.approveRequest.path,
    title: routeConstant.approveRequest.title,
    Component: PhNewApproveRequests
  },
  {
    path: routeConstant.partners.path,
    title: routeConstant.partners.title,
    Component: PhNewPartners
  },
  {
    path: routeConstant.partnerListings.path,
    title: routeConstant.partnerListings.title,
    Component: PartnersListing
  },
  {
    path: routeConstant.projectHeadTransactions.path,
    title: routeConstant.projectHeadTransactions.title,
    Component: PhNewTransaction
  },
  {
    path: routeConstant.allplanstransactions.path,
    title: routeConstant.allplanstransactions.title,
    Component: AllPlansTransactions
  },
  {
    path: routeConstant.books_summary.path,
    title: routeConstant.books_summary.title,
    Component: PhNewBooksSummary
  },
  {
    path: routeConstant.allBooksListings.path,
    title: routeConstant.allBooksListings.title,
    Component: AllBooksListings
  },
  {
    path: routeConstant.manageBooks.path,
    title: routeConstant.manageBooks.title,
    Component: ManageBooks
  },
  {
    path: routeConstant.controlCenter.path,
    title: routeConstant.controlCenter.title,
    Component: PhNewControlCenter
  },
  {
    path: routeConstant.leadershipBoard.path,
    title: routeConstant.leadershipBoard.title,
    Component: PhNewLeadershipBoard
  },
  {
    path: routeConstant.dashboardView.path,
    title: routeConstant.dashboardView.title,
    Component: PhNewDashboardView
  },
  {
    path: routeConstant.termsAndCondition.path,
    title: routeConstant.termsAndCondition.title,
    Component: PhNewTermsAndPolicy
  },
  {
    path: routeConstant.privacyPolicy.path,
    title: routeConstant.privacyPolicy.title,
    Component: PhNewTermsAndPolicy
  },
  {
    path: routeConstant.pendingTasks.path,
    title: routeConstant.pendingTasks.title,
    Component: PhNewPendingTasks
  },
  {
    path: routeConstant.allMou.path,
    title: routeConstant.allMou.title,
    Component: AllMou
  },
  {
    path: routeConstant.transactions.path,
    title: routeConstant.transactions.title,
    Component: Transactions
  },
  {
    path: routeConstant.bestSellers.path,
    title: routeConstant.bestSellers.title,
    Component: TopSales
  },
  {
    path: routeConstant.reviewersPerformance.path,
    title: routeConstant.reviewersPerformance.title,
    Component: ReviewersPerformace
  },
  {
    path: routeConstant.partnerAccount.path,
    title: routeConstant.partnerAccount.title,
    Component: PhNewPartnerAccount
  },
  {
    path: routeConstant.mou.path,
    title: routeConstant.mou.title,
    Component: MOU
  },
  {
    path: routeConstant.publisherProfile.path,
    title: routeConstant.publisherProfile.title,
    Component: PhNewPublisherProfile
  },
  {
    path: routeConstant.bookDetail.path,
    title: routeConstant.bookDetail.title,
    Component: BookDetail
  },
  {
    path: routeConstant.seriesDetail.path,
    title: routeConstant.seriesDetail.title,
    Component: SeriesDetail
  },
  {
    path: routeConstant.reviewerPerformance.path,
    title: routeConstant.reviewerPerformance.title,
    Component: ReviewerPerformance
  },
  {
    path: routeConstant.reportedUsers.path,
    title: routeConstant.reportedUsers.title,
    Component: ReportedUsers
  },
  {
    path: routeConstant.reports.path,
    title: routeConstant.reports.title,
    Component: ReportDetails
  },
  {
    path: routeConstant.mouHead.path,
    title: routeConstant.mouHead.title,
    Component: PhNewMouSignature
  },
  {
    path: routeConstant.phNewAllMouSignature.path,
    title: routeConstant.phNewAllMouSignature.title,
    Component: PhNewAllMouSignature
  },
  {
    path: routeConstant.singleAuthor.path,
    title: routeConstant.singleAuthor.title,
    Component: PhNewAuthorProfile
  },
  {
    path: routeConstant.newsletterSubscription.path,
    title: routeConstant.newsletterSubscription.title,
    Component: NewsLetterSubscriptions
  },
  {
    path: routeConstant.subscriptions.path,
    title: routeConstant.subscriptions.title,
    Component: Subscriptions
  },
  {
    path: routeConstant.customNotifications.path,
    title: routeConstant.customNotifications.title,
    Component: CustomNotifications
  },
  {
    path: routeConstant.notificationListings.path,
    title: routeConstant.notificationListings.title,
    Component: NotificationListings
  },
  {
    path: routeConstant.subscription.path,
    title: routeConstant.subscription.title,
    Component: Subscription,
  },
  {
    path: routeConstant.purchasedPlansHistory.path,
    title: routeConstant.purchasedPlansHistory.title,
    Component: PurchasedPlansHistory,
  },
];

let rolesRoutes = [
  {
    role_id: 1,
    title: "Project Head",
    routes: projectHeadRoutes,
  },
  {
    role_id: 2,
    title: "HOD",
    routes: HODRoutes,
  },
  {
    role_id: 3,
    title: "Book Reviewer",
    routes: bookReviewerRoutes,
  },
  {
    role_id: 4,
    title: "Product Manager",
    routes: productManagerRoutes,
  },
  {
    role_id: 5,
    title: "Accountant",
    routes: accountantRoutes,
  },
  {
    role_id: 6,
    title: "Admin",
    routes: adminRoutes
  },
  {
    role_id: 7,
    title: "Project Head (New)",
    routes: projectHeadNewRoutes
  }
];

export {
  accountantRoutes,
  adminRoutes,
  bookReviewerRoutes,
  HODRoutes,
  productManagerRoutes,
  projectHeadRoutes,
  publicRoutes,
  rolesRoutes,
  projectHeadNewRoutes
};
